module.exports = __webpack_public_path__ + "media/assets/img/flags/ro-RO-d5073ab2ca9ee7c06c3f4d761968ac44.png";